  function switchProductDisplayed(evt, elementTitle, id){
    //console.log(elementTitle +' ------  '+ id);

    var i, tabcontent, tablinks, tabBtn, contentEle;

    var divAux = 'combo-' + id;
    var div = document.getElementById(divAux);
    //console.log(div);
    var auxtabcontent =   "tabcontent" +'-' + id;
    tabcontent = div.getElementsByClassName(auxtabcontent);
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].classList.remove('active');
      }

    var auxtablinks =   "tablinks";  
    tablinks = div.getElementsByClassName(auxtablinks);
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove('active');
    }

    var auxElement =   elementTitle + '-' + id;
    //console.log(' ------  '+ auxElement);
    contentEle = div.getElementsByClassName(auxElement);
    //console.log(' ------ contentEle '+ contentEle);
    for (i = 0; i < contentEle.length; i++) {
      contentEle[i].style.display = "block";
      contentEle[i].classList.add('active');
    }  
        
    var auxfrst = '#frst-' + id;
    var auxscnd = '#scnd-' + id;  
    $(auxfrst)[0].classList.remove('active');
    $(auxscnd)[0].classList.remove('active');

    //console.log(evt.currentTarget.classList);
    evt.currentTarget.classList.add('active');
  }
